<template>
<div class="icons-tab">

  <canvas style="display: none;" id="canvas" width="100px" height="100px"></canvas>
  <div class="colors">
    <div @click="choseColor(0)" :class="{ 'chosen' :  color===0}" class="color blue"></div>
    <div @click="choseColor(1)" :class="{ 'chosen' :  color===1}" class="color sky"></div>
    <div @click="choseColor(2)" :class="{ 'chosen' :  color===2}" class="color green"></div>
    <div @click="choseColor(3)" :class="{ 'chosen' :  color===3}" class="color yellow"></div>
    <div @click="choseColor(4)" :class="{ 'chosen' :  color===4}" class="color violet"></div>
    <div @click="choseColor(5)" :class="{ 'chosen' :  color===5}" class="color pink"></div>
  </div>
  <div class="icons">
    <button   @click="chose(0)"   :class="{ 'chosen' :  chosen===0}" class="icon">

      <svg  viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5027 12.4287L21.6815 20.6358C21.9447 20.848 22.0495 21.2007 21.9449 21.5222C21.8404 21.8437 21.5481 22.0672 21.2104 22.0839L8.42607 22.7178C8.73599 25.1566 9.88223 27.4728 11.6847 29.5402C16.3579 34.9 24.2835 35.5899 29.6078 30.9478C34.2237 26.9233 35.7378 20.422 33.1856 15.3299C32.7566 14.4739 32.2117 13.6544 31.5445 12.8892C31.533 12.876 31.522 12.8624 31.5113 12.8485C28.3163 8.66853 23.8767 7.69883 19.8472 8.29817C17.8253 8.59891 15.9234 9.29503 14.3712 10.1701C13.1263 10.8719 12.1446 11.6669 11.5027 12.4287ZM32.7901 11.8381C29.1551 7.09869 24.0723 6.02217 19.6075 6.68626C17.3789 7.01773 15.288 7.7825 13.5709 8.7505C11.8669 9.71119 10.4704 10.9069 9.69565 12.1419C9.47627 12.4916 9.55308 12.9501 9.87445 13.2092L18.9939 20.5622L7.50006 21.1321C7.28418 21.1428 7.08139 21.2389 6.93634 21.3991C6.79128 21.5594 6.71583 21.7707 6.7266 21.9865C6.88494 25.1599 8.26601 28.0989 10.4564 30.6111C15.6948 36.6193 24.6465 37.4356 30.6788 32.1761C35.787 27.7223 37.5665 20.4335 34.6425 14.5997C34.1559 13.6288 33.54 12.7015 32.7901 11.8381ZM26.7385 13.75C27.04 14.555 26.9655 15.3835 26.7883 15.9726C26.6588 16.4036 26.2044 16.6479 25.7734 16.5183C25.3425 16.3887 25.0981 15.9343 25.2277 15.5034C25.3308 15.1604 25.3579 14.7103 25.2124 14.3215C25.0825 13.9748 24.7869 13.5925 24.0555 13.3659C23.1706 13.0918 22.348 13.7087 22.1039 14.4073C21.9555 14.8321 21.4908 15.0561 21.0659 14.9077C20.6411 14.7593 20.417 14.2945 20.5655 13.8697C21.0126 12.5901 22.5854 11.2044 24.5379 11.8093C25.7211 12.1759 26.4212 12.9028 26.7385 13.75Z" :fill=" chosen===0 ?   '#06364B' : '#A2A2A2'"/>
      </svg>

    </button>
    <button   @click="chose(1)" :class="{ 'chosen' :  chosen===1}" class="icon">
      <svg   viewBox="0 0 42 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.9148 16.9118C25.5647 13.3534 33.843 16.0906 37.3715 22.7969C40.9 29.5032 38.1858 37.8518 31.536 41.4103C24.8861 44.9687 16.6077 42.2314 13.0792 35.5252C9.55073 28.8189 12.265 20.4702 18.9148 16.9118ZM32.4859 43.3263C40.2215 39.2205 43.2071 29.6401 39.2715 21.8389C35.2002 14.0377 25.7004 11.0267 17.9648 14.9957C10.2293 19.1016 7.24364 28.682 11.1793 36.4832C15.2506 44.2844 24.7504 47.4322 32.4859 43.3263Z"   :fill=" chosen===1 ?   '#06364B' : '#A2A2A2'"/>
        <path d="M31.13 24.713C30.7229 24.9867 30.18 24.713 30.0443 24.3024C29.7729 23.6181 28.9586 23.4812 28.2801 23.755C27.6015 24.0287 27.4658 24.8499 27.7372 25.5342C28.0086 25.9448 27.7372 26.4922 27.3301 26.6291C26.9229 26.9028 26.3801 26.6291 26.2444 26.2185C25.4301 24.713 26.1087 22.9338 27.4658 22.1126C28.9586 21.2914 30.7229 21.9757 31.5371 23.3444C31.6728 24.0287 31.5371 24.5761 31.13 24.713Z" :fill=" chosen===1 ?   '#06364B' : '#A2A2A2'"/>
        <path d="M22.8507 29.0909C22.4436 29.3646 21.9007 29.0909 21.765 28.6803C21.4936 27.996 20.6793 27.8592 20.0008 28.1329C19.3222 28.4066 19.1865 29.2278 19.4579 29.9121C19.7293 30.3227 19.4579 30.8701 19.0508 31.007C18.6436 31.2807 18.1008 31.007 17.9651 30.5964C17.1508 29.0909 17.8294 27.3117 19.1865 26.4905C20.6793 25.6694 22.4436 26.3537 23.2578 27.7223C23.3935 28.2697 23.2578 28.8172 22.8507 29.0909Z" :fill=" chosen===1 ?   '#06364B' : '#A2A2A2'"/>
        <path d="M21.7604 3.22598C22.5747 2.13108 24.4747 3.36285 23.5247 4.32089C22.0319 6.10011 22.7104 8.28992 23.9318 10.0691C22.8461 7.05815 23.5247 3.63657 25.8318 1.17304C26.7817 0.214997 28.2746 1.72049 27.3246 2.67853C25.8318 4.32089 25.2889 6.37383 25.8318 8.28992C26.646 6.64756 27.7317 5.14207 29.496 4.32089C30.7174 3.77344 31.6673 5.68952 30.4459 6.23697C27.7317 7.46874 27.0532 10.4797 26.5103 13.217C26.5103 13.3538 26.3746 13.4907 26.3746 13.6276C26.1032 14.3119 25.2889 14.8593 24.6104 14.175C22.1676 11.4378 18.7748 6.92129 21.7604 3.22598Z" :fill=" chosen===1 ?   '#06364B' : '#A2A2A2'" />
        <path d="M4.79981 12.2601C3.44269 12.397 3.30698 14.4499 4.6641 14.4499C6.97119 14.3131 8.3283 16.0923 9.14257 18.1452C7.37832 15.5448 4.25696 14.0393 0.86418 14.5868C-0.492933 14.8605 -0.0857987 16.9135 1.27131 16.6397C3.4427 16.2292 5.34265 17.1872 6.69977 18.6927C4.93552 18.2821 3.03556 18.419 1.40703 19.5139C0.185624 20.1982 1.27131 22.1143 2.357 21.43C4.93552 19.7876 7.78546 21.1562 10.2283 22.1143C10.364 22.1143 10.4997 22.2511 10.6354 22.2511C11.314 22.5249 12.2639 21.9774 11.9925 21.0194C11.1782 17.3241 9.5497 11.9864 4.79981 12.2601Z" :fill=" chosen===1 ?   '#06364B' : '#A2A2A2'" />
      </svg>

    </button>
    <button style="margin-top: 5px;"  @click="chose(2)" :class="{ 'chosen' :  chosen===2}" class="icon">
      <svg   viewBox="-5 -2 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.4533 12.0067C13.6277 10.3667 6.42039 11.1279 3.18755 11.7136C3.18746 12.0067 3.18751 12.2996 3.18755 12.5925C3.75809 12.8854 4.32859 14.7402 4.32859 15.5212C4.51875 16.9856 6.15416 19.8557 11.1746 19.6214C16.195 19.3871 16.1189 14.4473 15.4533 12.0067ZM15.4533 12.0067C16.5944 10.6009 18.0206 11.421 18.5911 12.0067M18.5911 12.0067C20.4167 10.3667 27.6241 11.1279 30.8569 11.7136C30.857 12.0067 30.8569 12.2996 30.8569 12.5925C30.2864 12.8854 29.7159 14.7402 29.7159 15.5212C29.5257 16.9856 27.8903 19.8557 22.8699 19.6214C17.8495 19.3871 17.9255 14.4473 18.5911 12.0067Z"  :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" stroke-width="2"/>
        <path d="M23.145 15.4062C22.8697 15.4062 22.6451 15.6449 22.6451 15.9375C22.6451 16.2301 22.8697 16.4687 23.145 16.4687C23.4204 16.4687 23.645 16.2301 23.645 15.9375C23.645 15.6449 23.4204 15.4062 23.145 15.4062Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M21.1453 15.4062C20.8699 15.4062 20.6453 15.6449 20.6453 15.9375C20.6453 16.2301 20.8699 16.4687 21.1453 16.4687C21.4206 16.4687 21.6452 16.2301 21.6452 15.9375C21.6452 15.6449 21.4206 15.4062 21.1453 15.4062Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M22.1451 14.3437C21.8698 14.3437 21.6452 14.5824 21.6452 14.875C21.6452 15.1676 21.8698 15.4062 22.1451 15.4062C22.4205 15.4062 22.6451 15.1676 22.6451 14.875C22.6451 14.5824 22.4205 14.3437 22.1451 14.3437Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M21.1453 13.2812C20.8699 13.2812 20.6453 13.5199 20.6453 13.8125C20.6453 14.1051 20.8699 14.3437 21.1453 14.3437C21.4206 14.3437 21.6452 14.1051 21.6452 13.8125C21.6452 13.5199 21.4206 13.2812 21.1453 13.2812Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M23.145 13.2812C22.8697 13.2812 22.6451 13.5199 22.6451 13.8125C22.6451 14.1051 22.8697 14.3437 23.145 14.3437C23.4204 14.3437 23.645 14.1051 23.645 13.8125C23.645 13.5199 23.4204 13.2812 23.145 13.2812Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M24.1449 14.3437C23.8696 14.3437 23.645 14.5824 23.645 14.875C23.645 15.1676 23.8696 15.4062 24.1449 15.4062C24.4203 15.4062 24.6449 15.1676 24.6449 14.875C24.6449 14.5824 24.4203 14.3437 24.1449 14.3437Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M25.1448 13.2812C24.8695 13.2812 24.6449 13.5199 24.6449 13.8125C24.6449 14.1051 24.8695 14.3437 25.1448 14.3437C25.4202 14.3437 25.6448 14.1051 25.6448 13.8125C25.6448 13.5199 25.4202 13.2812 25.1448 13.2812Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M26.1447 14.3437C25.8694 14.3437 25.6448 14.5824 25.6448 14.875C25.6448 15.1676 25.8694 15.4062 26.1447 15.4062C26.4201 15.4062 26.6447 15.1676 26.6447 14.875C26.6447 14.5824 26.4201 14.3437 26.1447 14.3437Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M25.1448 15.4062C24.8695 15.4062 24.6449 15.6449 24.6449 15.9375C24.6449 16.2301 24.8695 16.4687 25.1448 16.4687C25.4202 16.4687 25.6448 16.2301 25.6448 15.9375C25.6448 15.6449 25.4202 15.4062 25.1448 15.4062Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M24.1449 16.4687C23.8696 16.4687 23.645 16.7074 23.645 17C23.645 17.2926 23.8696 17.5312 24.1449 17.5312C24.4203 17.5312 24.6449 17.2926 24.6449 17C24.6449 16.7074 24.4203 16.4687 24.1449 16.4687Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M22.1451 16.4687C21.8698 16.4687 21.6452 16.7074 21.6452 17C21.6452 17.2926 21.8698 17.5312 22.1451 17.5312C22.4205 17.5312 22.6451 17.2926 22.6451 17C22.6451 16.7074 22.4205 16.4687 22.1451 16.4687Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M27.1446 13.2812C26.8693 13.2812 26.6447 13.5199 26.6447 13.8125C26.6447 14.1051 26.8693 14.3437 27.1446 14.3437C27.42 14.3437 27.6446 14.1051 27.6446 13.8125C27.6446 13.5199 27.42 13.2812 27.1446 13.2812Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M12.9583 15.4062C12.6829 15.4062 12.4583 15.6449 12.4583 15.9375C12.4583 16.2301 12.6829 16.4687 12.9583 16.4687C13.2336 16.4687 13.4582 16.2301 13.4582 15.9375C13.4582 15.6449 13.2336 15.4062 12.9583 15.4062Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M11.9584 14.3437C11.683 14.3437 11.4584 14.5824 11.4584 14.875C11.4584 15.1676 11.683 15.4062 11.9584 15.4062C12.2337 15.4062 12.4583 15.1676 12.4583 14.875C12.4583 14.5824 12.2337 14.3437 11.9584 14.3437Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M12.9583 13.2812C12.6829 13.2812 12.4583 13.5199 12.4583 13.8125C12.4583 14.1051 12.6829 14.3437 12.9583 14.3437C13.2336 14.3437 13.4582 14.1051 13.4582 13.8125C13.4582 13.5199 13.2336 13.2812 12.9583 13.2812Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M10.9585 13.2812C10.6831 13.2812 10.4585 13.5199 10.4585 13.8125C10.4585 14.1051 10.6831 14.3437 10.9585 14.3437C11.2338 14.3437 11.4584 14.1051 11.4584 13.8125C11.4584 13.5199 11.2338 13.2812 10.9585 13.2812Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M8.95867 13.2812C8.68331 13.2812 8.45872 13.5199 8.45872 13.8125C8.45872 14.1051 8.68331 14.3437 8.95867 14.3437C9.23403 14.3437 9.45862 14.1051 9.45862 13.8125C9.45862 13.5199 9.23403 13.2812 8.95867 13.2812Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M9.95857 14.3437C9.68321 14.3437 9.45862 14.5824 9.45862 14.875C9.45862 15.1676 9.68321 15.4062 9.95857 15.4062C10.2339 15.4062 10.4585 15.1676 10.4585 14.875C10.4585 14.5824 10.2339 14.3437 9.95857 14.3437Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M7.95877 14.3437C7.68341 14.3437 7.45882 14.5824 7.45882 14.875C7.45882 15.1676 7.68341 15.4062 7.95877 15.4062C8.23414 15.4062 8.45872 15.1676 8.45872 14.875C8.45872 14.5824 8.23414 14.3437 7.95877 14.3437Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M8.95867 15.4062C8.68331 15.4062 8.45872 15.6449 8.45872 15.9375C8.45872 16.2301 8.68331 16.4687 8.95867 16.4687C9.23403 16.4687 9.45862 16.2301 9.45862 15.9375C9.45862 15.6449 9.23403 15.4062 8.95867 15.4062Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M6.95888 13.2812C6.68351 13.2812 6.45893 13.5199 6.45893 13.8125C6.45893 14.1051 6.68351 14.3437 6.95888 14.3437C7.23424 14.3437 7.45882 14.1051 7.45882 13.8125C7.45882 13.5199 7.23424 13.2812 6.95888 13.2812Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M9.95857 16.4687C9.68321 16.4687 9.45862 16.7074 9.45862 17C9.45862 17.2926 9.68321 17.5312 9.95857 17.5312C10.2339 17.5312 10.4585 17.2926 10.4585 17C10.4585 16.7074 10.2339 16.4687 9.95857 16.4687Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M10.9585 15.4062C10.6831 15.4062 10.4585 15.6449 10.4585 15.9375C10.4585 16.2301 10.6831 16.4687 10.9585 16.4687C11.2338 16.4687 11.4584 16.2301 11.4584 15.9375C11.4584 15.6449 11.2338 15.4062 10.9585 15.4062Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <path d="M11.9584 16.4687C11.683 16.4687 11.4584 16.7074 11.4584 17C11.4584 17.2926 11.683 17.5312 11.9584 17.5312C12.2337 17.5312 12.4583 17.2926 12.4583 17C12.4583 16.7074 12.2337 16.4687 11.9584 16.4687Z" :fill=" chosen===2 ?   '#06364B' : '#A2A2A2'" />
        <circle cx="17" cy="17" r="16" :stroke=" chosen===2 ?   '#06364B' : '#A2A2A2'" stroke-width="2"/>
      </svg>

    </button>
    <button   @click="chose(3)" :class="{ 'chosen' :  chosen===3}" class="icon">
      <svg   viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.1904 7.9384L22.4707 21.8372C22.659 22.1966 22.6058 22.6349 22.337 22.9387C22.0682 23.2426 21.6397 23.3489 21.26 23.2059L6.88572 17.7925C6.06107 20.6249 6.21552 23.7222 7.21123 26.8593C9.79268 34.9925 18.1864 39.5404 26.2656 36.9761C33.2699 34.753 38.0442 28.3211 37.6692 21.4963C37.6061 20.3491 37.3981 19.1866 37.0296 18.0255C37.0232 18.0055 37.0175 17.9853 37.0125 17.9649C35.4939 11.8368 31.0709 8.64732 26.3494 7.38084C23.9802 6.74536 21.5541 6.6024 19.4274 6.82359C17.7216 7.00099 16.2611 7.4067 15.1904 7.9384ZM38.903 17.464C37.1676 10.5099 32.0877 6.89537 26.856 5.49207C24.2447 4.79164 21.5777 4.63386 19.2251 4.87854C16.8903 5.12137 14.7817 5.7699 13.3386 6.7589C12.9299 7.03893 12.7953 7.58031 13.0252 8.01913L19.5478 20.4715L6.6245 15.6045C6.38177 15.5131 6.11267 15.5219 5.87641 15.6289C5.64015 15.736 5.4561 15.9325 5.36476 16.1752C4.02213 19.7437 4.13734 23.6387 5.34733 27.4509C8.24104 36.5679 17.7036 41.7453 26.8572 38.84C34.6086 36.3797 40.0514 29.2078 39.6218 21.389C39.5503 20.0878 39.3156 18.7727 38.903 17.464Z" :fill=" chosen===3 ?   '#06364B' : '#A2A2A2'"/>
        <path d="M24.916 11.9131C24.2424 13.6263 23.9599 17.0397 28.2186 16.9879" :stroke=" chosen===3 ?   '#06364B' : '#A2A2A2'" stroke-width="2" stroke-linecap="round"/>
      </svg>

    </button>

    <button  @click="chose(4)" :class="{ 'chosen' :  chosen===4}" class="icon">
      <svg   viewBox="4 7 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M34.4958 19.6197L33.7397 20.2742C33.7538 20.2904 33.7684 20.3062 33.7835 20.3215L34.4958 19.6197ZM23.1031 30.075L23.2132 31.0689C23.6256 31.0232 23.9669 30.7276 24.0711 30.326C24.1752 29.9243 24.0205 29.5001 23.6822 29.2598L23.1031 30.075ZM8.2821 31.7179L8.17193 30.724C7.90828 30.7532 7.66704 30.886 7.5013 31.0931C7.33556 31.3002 7.25892 31.5647 7.28822 31.8283L8.2821 31.7179ZM10.763 21.3078L9.8851 20.8289C9.64246 21.2737 9.77077 21.8296 10.1838 22.123L10.763 21.3078ZM27.0388 23.4905C26.9122 24.0281 27.2454 24.5665 27.783 24.6931C28.3206 24.8196 28.859 24.4864 28.9856 23.9488L27.0388 23.4905ZM25.9363 20.3973L26.1736 19.4259L25.9363 20.3973ZM21.8464 22.0138C21.6962 22.5453 22.0054 23.0979 22.5369 23.248C23.0684 23.3981 23.6209 23.089 23.771 22.5575L21.8464 22.0138ZM36.5839 22.351L35.7188 22.8526L36.5839 22.351ZM32.8723 39.9917C27.4185 45.3643 18.7976 45.1428 13.3851 39.6486L11.9603 41.0522C18.1137 47.2984 28.0009 47.5981 34.2758 41.4164L32.8723 39.9917ZM13.3851 39.6486C11.0629 37.2914 9.60349 34.5538 9.27598 31.6074L7.28822 31.8283C7.67503 35.3082 9.39071 38.4438 11.9603 41.0522L13.3851 39.6486ZM8.39227 32.7118L23.2132 31.0689L22.9929 29.0811L8.17193 30.724L8.39227 32.7118ZM10.1838 22.123L22.5239 30.8902L23.6822 29.2598L11.3421 20.4926L10.1838 22.123ZM11.6408 21.7868C12.2011 20.7598 13.37 19.5727 15.0095 18.5121C16.6336 17.4614 18.6494 16.5812 20.8209 16.1217C25.1466 15.2065 30.0091 15.9643 33.7397 20.2742L35.2519 18.9653C30.9379 13.9814 25.269 13.1363 20.4069 14.165C17.9845 14.6776 15.7423 15.656 13.9232 16.8328C12.1194 17.9997 10.6598 19.4088 9.8851 20.8289L11.6408 21.7868ZM28.9856 23.9488C29.1436 23.2777 29.1714 22.3436 28.7769 21.4582C28.36 20.5224 27.5195 19.7547 26.1736 19.4259L25.699 21.3687C26.4808 21.5597 26.8001 21.9355 26.9501 22.2722C27.1225 22.6592 27.1245 23.1264 27.0388 23.4905L28.9856 23.9488ZM26.1736 19.4259C23.9309 18.8779 22.2603 20.5485 21.8464 22.0138L23.771 22.5575C23.9796 21.8192 24.7886 21.1463 25.699 21.3687L26.1736 19.4259ZM33.7835 20.3215C34.5555 21.1052 35.1987 21.9555 35.7188 22.8526L37.449 21.8494C36.8445 20.8069 36.0988 19.822 35.2082 18.9179L33.7835 20.3215ZM35.7188 22.8526C38.8129 28.1887 37.608 35.3263 32.8723 39.9917L34.2758 41.4164C39.5827 36.1884 41.0538 28.0663 37.449 21.8494L35.7188 22.8526ZM37.397 22.9331C38.2437 21.7506 41.7362 19.2686 48.1776 21.8253L48.9154 19.9663C41.7501 17.1224 37.2298 19.731 35.7708 21.7688L37.397 22.9331ZM36.6094 23.3506C38.8706 23.293 42.167 23.4388 44.7397 24.0389C46.0413 24.3425 47.0433 24.7375 47.6424 25.1961C47.9317 25.4176 48.0832 25.6208 48.1547 25.792C48.2198 25.948 48.2456 26.1389 48.1726 26.409L50.1032 26.931C50.2828 26.2668 50.2496 25.6184 50.0002 25.0213C49.7572 24.4395 49.3385 23.9758 48.8581 23.608C47.9177 22.8881 46.5815 22.4149 45.1941 22.0912C42.3886 21.4367 38.9029 21.2915 36.5584 21.3513L36.6094 23.3506ZM36.8943 23.3016C37.8476 22.9904 39.354 22.8723 40.7217 23.5013C42.0284 24.1022 43.3799 25.4637 43.957 28.458L45.9209 28.0794C45.2438 24.5668 43.549 22.6001 41.5573 21.6842C39.6268 20.7964 37.5827 20.9729 36.2736 21.4004L36.8943 23.3016Z" :fill=" chosen===4 ?   '#06364B' : '#A2A2A2'"/>
        <path d="M41.1294 37.6519C40.927 39.7241 39.308 44.4338 34.451 46.6944M44.7721 35.6738C44.9745 37.0867 44.9542 40.3646 43.2543 42.1731" :stroke=" chosen===4 ?   '#06364B' : '#A2A2A2'" stroke-width="2" stroke-linecap="round"/>
      </svg>

    </button>
  </div>
</div>
</template>

<script>
export default {
  data(){
    return{
      img: '',
      chosen: '',
      color: 0,
      colors:['#5284A9','#A0CCDA','#52AA8A','#FDC671','#925090', '#FF7384'],
    }
  },

  methods:{
    choseColor(value){
      this.color = value;
      if (this.chosen===''){
        this.chosen = 0;
      }
      setTimeout(()=>{
        this.getImage();
      },100)
    },
    chose(value){
      this.chosen = value;
      setTimeout(()=>{
        this.getImage();
      },100)
    },
    changeColor(node) {

        if(!node.hasAttribute) {
          return;
        }

      if(node.hasAttribute('fill') && node.getAttribute('fill')!=='white') {
        node.setAttribute('fill', 'white');
      }  if(node.hasAttribute('stroke') && node.getAttribute('stroke')!=='white') {
          node.setAttribute('stroke', 'white');
    }

    },
    getImage(){
      var svg = document.querySelector('.chosen svg');
      var img = new Image();
      var canvas = document.getElementById('canvas');
      let cloned = svg.cloneNode(true);

      let nodes = cloned.childNodes;
      for (const i in nodes) {
        this.changeColor(nodes[i]);
      }

        if (this.chosen===4){
          cloned.setAttribute('width', '60px');
          cloned.setAttribute('height', '50px');
        } else {
          cloned.setAttribute('width', '55px');
          cloned.setAttribute('height', '55px');
        }


      var xml = new XMLSerializer().serializeToString(cloned);
      var svg64 = btoa(xml);
      var b64Start = 'data:image/svg+xml;base64,';
      var image64 = b64Start + svg64;
      var color = this.colors[this.color];



      let cntxt = this;
      img.onload = function() {

        let context = canvas.getContext('2d');
        context.clearRect(0, 0, 100, 100);
        context.rect(0, 0, 110, 110);
        context.fillStyle =  color;
        context.fill();
        context.drawImage(img, 21 , 21 );
        var canvasData = canvas.toDataURL("image/png");
        cntxt.$emit('change', canvasData);

      };
      img.src = image64;


    }
  },
};
</script>

<style lang="scss" scoped>
.icons-tab{


  .colors{
    margin: 0 auto;
    width: 285px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 374px){
      width: 245px;
    }
    .color{
      width: 30px;
      height: 30px;
      border-radius: 50%;

      &.chosen{
        position: relative;

        &:after{
          position: absolute;
          top: -6px;
          right: -6px;
          content: "";
          width: 42px;
          height: 42px;
          background: transparent;
          border: 1px solid #00465B;
          border-radius: 50%;
        }
      }
      &.blue{
        background: #5284A9;
      }
      &.sky{
        background: #A0CCDA;
      }
      &.green{
        background: #52AA8A;
      }
      &.yellow{
        background: #FDC671;
      }
      &.violet{
        background: #925090;
      }
      &.pink{
        background: #FF7384;
      }
    }
  }
  .icons{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 319px;
    margin: 15px auto 0;
    @media screen and (max-width: 374px){
      width: 245px;
    }

    .icon{
      position: relative;
      height: 55px;
      width: 55px;
      border-radius: 50%;
      border: 2px solid white;
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 375px) {
        height: 51px;
        width: 51px;
      }
      svg{
        padding: 5px;
        &.white{
          width: 43px;
          height: 43px;
          path{
            fill:white!important;
          }
        }
        width: 43px;
        height: 43px;
        path{
          fill:#A2A2A2;
        }
      }
      /*&:after{*/
      /*  position: absolute;*/
      /*  top: 0;*/
      /*  right: 0;*/
      /*  content:"";*/
      /*  width: 12px;*/
      /*  height: 12px;*/
      /*  background: #FFFFFF;*/
      /*  border: 1px solid #00465B;*/
      /*  border-radius: 50%;*/
      /*}*/
      &.chosen{

        border-radius: 50%;
        border: 1px solid #00465B;
        svg{

          path{
            fill:#06364B;
          }
        }
        /*&:before{*/
        /*  position: absolute;*/
        /*  content:"";*/
        /*  top: 3px;*/
        /*  right: 3px;*/
        /*  width: 6px;*/
        /*  height: 6px;*/
        /*  background: #00465B;*/
        /*  border-radius: 50%;*/
        /*  z-index: 88;*/
        /*}*/
      }
    }
  }
}
</style>
